<section>
  <div class="content-wrapper">
    <section class="login-register-page">
      <div class="social-wrapper">
        <h2>{{ pageData?.social_heading }}</h2>
        <app-social-login-buttons></app-social-login-buttons>
      </div>
      <div class="login-wrapper">
        <h2>{{ pageData?.email_heading }}</h2>
        <form class="login-form" [formGroup]="loginForm" (ngSubmit)="onLogin()">
          <div class="form-field">
            <label for="email">Email address</label>
            <input
              type="email"
              id="email"
              class="email"
              formControlName="email"
              [class.error]="submitted && formControl['email'].errors"
            />
            <ng-container *ngIf="submitted && formControl['email'].errors">
              <span
                *ngIf="formControl['email'].errors['required']"
                class="error"
              >
                {{ pageData.email_address_empty_error }}
              </span>
              <span *ngIf="formControl['email'].errors['email']" class="error">
                {{ pageData.email_address_invalid_error }}
              </span>
            </ng-container>
          </div>
          <div class="form-field">
            <label for="password">Password</label>
            <input
              type="password"
              id="password"
              class="password"
              formControlName="password"
              [class.error]="submitted && formControl['password'].errors"
            />
            <ng-container *ngIf="submitted && formControl['password'].errors">
              <span
                *ngIf="formControl['password'].errors['required']"
                class="error"
              >
                {{ pageData.password_empty_error }}
              </span>
            </ng-container>
          </div>
          <app-error-block
            *ngIf="
              !loginNotFound &&
              !accountLocked &&
              (authService.logoutReason === 401 ||
                authService.logoutReason === 419)
            "
          >
            {{
              authService.logoutReason === 401
                ? pageData.session_expired
                : pageData.csrf_error
            }}
          </app-error-block>
          <app-error-block *ngIf="unverified">
            <ng-container
              *ngIf="!verificationResent; else verificationResentText"
            >
              Your address is not verified. Click
              <a class="error-block-link" (click)="resendVerification()">
                here</a
              >
              to resend verification email.
            </ng-container>
            <ng-template #verificationResentText>
              Email resent. Please check your inbox.
            </ng-template>
          </app-error-block>
          <app-error-block *ngIf="accountLocked">
            {{ pageData.account_locked }}
          </app-error-block>
          <app-error-block *ngIf="loginNotFound && !accountLocked">
            {{ pageData.login_incorrect }}
          </app-error-block>
          <app-error-block *ngIf="otherError">
            {{ otherErrorMessage }}
          </app-error-block>
          <div class="submit-container">
            <button
              class="button"
              [class.button-loading]="loggingIn"
              type="submit"
            >
              <span>Log in</span>
            </button>

            <div class="alternate-action-wrapper">
              <a [routerLink]="'/forgotten-password'">
                {{ pageData.forgotten_password_text }}
              </a>
              <br />
              <a [routerLink]="'/registration'">
                {{ pageData.register_link_text }}
              </a>
            </div>
          </div>
        </form>
      </div>
    </section>
  </div>
</section>
